import options from './thing-updated.component';

export default {
    selector: 'dtAsThingUpdated',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-updated/index.js